<template>
  <div class="inner-dashboard">
    <loading
      v-model:active="campaignLoading"
      :is-full-page="true"
      loader="dots"
      :opacity="1"
    />
    <PropertyDashboardSidebarNav
      v-if="!campaignLoading"
      :propertyId="propertyId"
      :campaignId="campaignId"
      :showLeadIntro="showLeadIntro"
      :showTopIntro="showTopIntro"
    />
    <div class="container h-100 pt-4" v-if="!campaignLoading">
      <div
        class="property-dashboard-content-heading row justify-content-between mb-4"
      >
        <div class="heading-text col-12 col-md-6 mb-0">
          <div class="current-property">
            <button
              class="navbar-toggler ms-auto d-inline d-lg-none"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasMenu"
              aria-controls="offcanvasMenu"
            >
              <font-awesome-icon icon="compass" />
            </button>
            {{ campaignName }}
          </div>
          <div class="current-route">Leads</div>
        </div>
        <div
          class="col-12 col-md-6 buttons d-flex justify-content-end"
          v-if="campaignName"
        >
          <button
            type="button"
            class="btn btn-primary wti-btn wti-btn-white share-button ms-4"
            @click="generatePDF"
            :disabled="isLoading"
          >
            <span
              v-if="isLoading"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            {{ isLoading ? "" : "Download PDF" }}
          </button>
        </div>
      </div>
      <div class="mb-4">
        <button
          class="btn play-btn d-flex align-items-center"
          href="https://vimeo.com/1055637303"
          data-fancybox="gallery"
        >
          How does this report work?
          <img src="@/assets/play_1.png" class="play-btn-img" />
        </button>
      </div>
      <div class="position-relative section-data-conatiner">
        <loading
          v-model:active="isLoading"
          :is-full-page="false"
          loader="dots"
          :opacity="1"
        />
        <div
          v-if="!isLoading"
          class="row row-cols-1 row-cols-md-2 row-cols-lg-3"
        >
          <div
            v-for="(item, index) in contacts_identified"
            :key="index"
            class="col"
          >
            <div class="contact-container mb-4">
              <div class="d-flex">
                <div class="contact-logo-container">
                  <img
                    :src="item.logo"
                    class="contact-logo"
                    v-if="isUrl(item.logo)"
                  />
                  <img src="@/assets/user 1.png" class="contact-logo" v-else />
                </div>
                <div>
                  <div>
                    <a :href="item.linkedIn" target="_blank">
                      <img src="@/assets/linkedin.png" class="linkedin-logo" />
                    </a>
                  </div>
                  <p
                    class="contact-name"
                    :class="{
                      contact_name_s: item.name && item.name.length > 15,
                      contact_name_xs: item.name && item.name.length > 30,
                    }"
                  >
                    {{ item.name }}
                  </p>
                  <p class="contact-job-title">
                    {{ item.jobTitle }}
                  </p>
                </div>
              </div>

              <div class="contact-info">
                <p>
                  <img src="@/assets/company-icon.png" class="contact-icon" />
                  <span
                    :class="{
                      contact_info_s: item.company && item.company.length > 35,
                      contact_info_xs: item.company && item.company.length > 50,
                    }"
                    >{{ item.company }}</span
                  >
                </p>
                <p>
                  <img src="@/assets/website-icon.png" class="contact-icon" />
                  <span
                    :class="{
                      contact_info_s: item.website && item.website.length > 35,
                      contact_info_xs: item.website && item.website.length > 50,
                    }"
                    >{{ item.website }}</span
                  >
                </p>
                <p>
                  <img src="@/assets/phone-icon.png" class="contact-icon" />
                  <span
                    :class="{
                      contact_info_s: item.phone && item.phone.length > 35,
                      contact_info_xs: item.phone && item.phone.length > 50,
                    }"
                    >{{ item.phone }}</span
                  >
                </p>
                <p>
                  <img src="@/assets/email-icon.png" class="contact-icon" />
                  <span
                    :class="{
                      contact_info_s: item.email && item.email.length > 35,
                      contact_info_xs: item.email && item.email.length > 50,
                    }"
                    >{{ item.email }}</span
                  >
                </p>
                <p>
                  <img src="@/assets/calendar-icon.png" class="contact-icon" />
                  <span
                    :class="{
                      contact_info_s:
                        item.lastSeen && item.lastSeen.length > 35,
                      contact_info_xs:
                        item.lastSeen && item.lastSeen.length > 50,
                    }"
                    >Identified: {{ item.lastSeen }}</span
                  >
                </p>
                <p>
                  <img src="@/assets/page-icon.png" class="contact-icon" />
                  <span
                    :class="{
                      contact_info_s: item.pageUrl && item.pageUrl.length > 35,
                      contact_info_xs: item.pageUrl && item.pageUrl.length > 50,
                    }"
                    >{{ item.pageUrl }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@use "@/assets/vars.sass" as *
.section-data-conatiner
  min-height: 80px
.contact-container
  border: 1px solid #D9E1E7
  border-radius: 20px
  padding: 20px
  .contact-logo-container
    margin-right: 28px
    .contact-logo
      width: 95px
      height: 95px
      border-radius: 50%
      margin-bottom: 19px
      object-fit: cover
  .linkedin-logo
    width: 15px
    height: 15px
    margin-bottom: 9px
    margin-top: 15px
  .contact-name
    font-family: Sora
    font-size: 16px
    font-weight: 600
    line-height: 17.6px
    margin-bottom: 7px
    color: #1D1E25
  .contact_name_s
    font-size: 14px
  .contact_name_xs
    font-size: 14px
  .contact-job-title
    font-family: Sora
    font-size: 12px
    font-weight: 600
    line-height: 15.12px
    color: #809FB8
    margin-bottom: 0
  .contact-info
    p
      margin-bottom: 19px
      span
        font-family: Sora
        font-size: 12px
        font-weight: 400
        line-height: 18px
        text-align: start
        vertical-align: middle
        word-break: break-word
      .contact-icon
        width: 25px
        height: 25px
        margin-right: 16px
  .contact_info_s
    font-size: 10px !important
  .contact_info_xs
    font-size: 8px !important
.play-btn
  background-color: #4350F2
  color: #FFFFFF
  font-weight: 600
  font-size: 12px
  line-height: 12.6px
  text-align: center
  border-radius: 15px
  padding: 6px 8px
  .play-btn-img
    width: 20px
    height: 20px
    margin-left: 3px
.property-dashboard-content-heading
  margin-bottom: 10px !important
</style>

<script>
import { ref } from "vue";
import api from "@/services/BackendConnection";
import PropertyDashboardSidebarNav from "@/components/PropertyDashboardSidebarNav.vue";
import mockData from "@/utils/mockData.json";
import shannon_loew_logo from "../assets/shannon_loew.jpeg";
import craig_irwin_logo from "../assets/craig_irwin.jpeg";
import Jeff_Hardman_logo from "../assets/Jeff_Hardman.jpeg";
import trey_conway_logo from "../assets/trey_conway.jpeg";
import * as Fancybox from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default {
  name: "ContactsIdentifiedView",
  setup(props) {
    return {
      campaignName: ref(null),
      isLoading: ref(true),
      contacts_identified: ref([]),
      campaignLoading: ref(true),
      showLeadIntro: ref(null),
      showTopIntro: ref(null),
    };
  },
  props: {
    propertyId: {
      type: String,
      required: true,
    },
    campaignId: {
      type: String,
      required: true,
    },
  },
  components: {
    PropertyDashboardSidebarNav,
  },
  computed: {},
  methods: {
    isUrl(str) {
      const urlPattern =
        /^(https?:\/\/[\w.-]+(:\d+)?(\/[\w./-]*)?(\?[\w=&%.-]*)?|\/[\w./-]+)$/;
      return urlPattern.test(str);
    },
    getCampaignInfo() {
      this.campaignLoading = true;
      var info = {
        campaignId: this.campaignId,
      };
      var _this = this;
      api()
        .getCampaignName(info)
        .then((res) => {
          if (res.data) {
            _this.campaignName = res.data.campaignName;
            var monthlyBudget = res.data.monthlyBudget;
            var showLeadContacts = res.data.showLeadContacts;
            var showTopContacts = res.data.showTopContacts;
            _this.showLeadIntro =
              !showLeadContacts && monthlyBudget && monthlyBudget < 1000;
            _this.showTopIntro =
              !showTopContacts && monthlyBudget && monthlyBudget < 1000;
          }
          _this.campaignLoading = false;
        });
    },
    getContacts() {
      this.isLoading = true;
      var _this = this;
      if (
        this.campaignId == "652d4ce096d5ae0503069180" ||
        this.campaignId == "685c4bdcb856f40bca877fdf"
      ) {
        var mockContacts = JSON.parse(
          JSON.stringify(mockData.identifiedContacts)
        );
        mockContacts.forEach((mockContact) => {
          if (mockContact.logo) {
            switch (mockContact.logo) {
              case "shannon_loew.jpeg":
                mockContact.logo = shannon_loew_logo;
                break;
              case "craig_irwin.jpeg":
                mockContact.logo = craig_irwin_logo;
                break;
              case "Jeff_Hardman.jpeg":
                mockContact.logo = Jeff_Hardman_logo;
                break;
              case "trey_conway.jpeg":
                mockContact.logo = trey_conway_logo;
                break;
            }
          }
        });
        mockContacts.sort(
          (a, b) => new Date(b.lastSeen) - new Date(a.lastSeen)
        );
        this.contacts_identified = mockContacts;
        setTimeout(() => {
          _this.isLoading = false;
        }, 500);
      } else {
        var info = {
          propertyId: this.propertyId,
          showContacts: true,
        };
        api()
          .getMAContacts(info)
          .then((res) => {
            this.isLoading = false;
            if (res.data) {
              this.contacts_identified = res.data;
            }
          });
      }
    },
    generatePDF() {
      var campaignName = this.campaignName;
      var contactsIdentified = this.contacts_identified;
      if (
        this.campaignId == "652d4ce096d5ae0503069180" ||
        this.campaignId == "685c4bdcb856f40bca877fdf"
      ) {
        var mockContacts = JSON.parse(
          JSON.stringify(mockData.identifiedContacts)
        );
        mockContacts.forEach((mockContact) => {
          if (mockContact.logo) {
            mockContact.logo =
              import.meta.env.VITE_HOST_DOMAIN + "/images/" + mockContact.logo;
          }
        });
        contactsIdentified = mockContacts;
      }

      var reportData = {
        campaignName: campaignName,
        contactsIdentified: contactsIdentified,
      };
      var info = {
        reportData: reportData,
        templateName: "leads",
      };
      api()
        .generateReportPDFNew(info)
        .then((response) => {
          if (response.data instanceof Blob) {
            const fileURL = URL.createObjectURL(response.data);
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", `${campaignName}-Leads.pdf`);
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            URL.revokeObjectURL(fileURL);
          } else {
            console.error("Unexpected response data type:", response.data);
          }
        })
        .catch((error) => {
          console.error("PDF download failed:", error);
        });
    },
  },
  mounted() {
    this.getCampaignInfo();
    this.getContacts();
    Fancybox.Fancybox.bind("[data-fancybox]", {});
  },
};
</script>